import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { checkAuth, registerNavigationCallback } from './utils/authUtils';
import { authService } from './services/auth.service';

const AppContent: React.FC = () => {
  const navigate = useNavigate();
  const [isInitializing, setIsInitializing] = useState(true);

  // Register navigation callback and check authentication on app load
  useEffect(() => {
    const initAuth = async () => {
      try {
        // Register the navigation callback
        registerNavigationCallback(navigate);
        
        // Initialize auth state from refresh token if available
        await authService.initializeAuthState();
        
        // Check if the user is already authenticated
        // This will redirect to the appropriate page if needed
        checkAuth(navigate);
      } catch (error) {
        console.error('Error initializing auth:', error);
      } finally {
        setIsInitializing(false);
      }
    };

    // Set a timeout to prevent infinite loading
    const timeoutId = setTimeout(() => {
      setIsInitializing(false);
    }, 5000); // 5 seconds max loading time

    initAuth();

    return () => clearTimeout(timeoutId);
  }, [navigate]);

  if (isInitializing) {
    // Show loading state instead of blank screen
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  return <AppRoutes />;
};

export default AppContent; 